"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Sources;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const document_1 = require("../../store/selectors/document");
const document_2 = require("../../slices/document");
const useDevice_1 = require("../../hooks/useDevice");
const AppLoader_1 = __importDefault(require("../../component/AppLoader"));
const ScrollCustomIndicator_1 = __importDefault(require("../../component/ScrollCustomIndicator"));
const GradientButton_1 = require("../../component/GradientButton");
const AddSources_1 = __importDefault(require("../../component/AddSources"));
const SourceItem_1 = __importDefault(require("./SourceItem"));
const AppText_1 = require("../../component/AppText");
const colors_1 = require("../../common/colors");
const SourceLimitBar_1 = __importDefault(require("./SourceLimitBar"));
;
function Sources({ document, selectedFileIds }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const { navigate } = (0, native_1.useNavigation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const documentsSourcesLoading = (0, react_redux_1.useSelector)(document_1.selectDocumentsSourcesLoading);
    const [isAddOpened, setIsAddOpened] = (0, react_1.useState)(false);
    const isLoading = (0, react_1.useMemo)(() => (documentsSourcesLoading.some((documentId) => documentId === document.character_id)), [document, documentsSourcesLoading]);
    const openAddSources = (0, react_1.useCallback)(() => {
        if (isMobileScreen && !('shareId' in document)) {
            navigate('AddSources', { document });
        }
        else {
            setIsAddOpened(true);
        }
    }, [document, isMobileScreen, navigate]);
    const closeSourceModal = (0, react_1.useCallback)(() => {
        setIsAddOpened(false);
    }, []);
    const handleClose = (0, react_1.useCallback)(() => {
        dispatch((0, document_2.setIsSourcesOpen)(false));
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { colors: [colors_1.Colors.DARK_700, colors_1.Colors.DARK_600], style: [
                    styles.content,
                    isMobileScreen && { borderRadius: 0 }
                ], children: [(0, jsx_runtime_1.jsx)(AppLoader_1.default, { showLoader: true, isLoading: isLoading }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.header, isMobileScreen && { borderRadius: 0 }], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.title, children: "Sources" }), !('shareId' in document) && ((0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: colors_1.Colors.NEUTRAL_00, size: 16 }), iconOnly: true, fullWidth: false, onPress: openAddSources })), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleClose, style: styles.closeContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClose, color: colors_1.Colors.white, size: 16 }) })] }), (0, jsx_runtime_1.jsx)(SourceLimitBar_1.default, { current: document.files?.length ?? 1, total: 10 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.description, children: "Choose your information sources" }), (0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { customIndicator: !isMobileScreen, contentContainerStyle: styles.sourcesContainer, children: document.files ? document.files.map((file) => ((0, jsx_runtime_1.jsx)(SourceItem_1.default, { file: file, selected: selectedFileIds
                                && selectedFileIds.some((selectedFileId) => selectedFileId === file.id) }))) : !('shareId' in document) && document.fileId && document.fileUrl && ((0, jsx_runtime_1.jsx)(SourceItem_1.default, { file: {
                                id: document.fileId,
                                fileName: document.title,
                                urlPath: document.fileUrl,
                                selected: 'Y',
                                sourceUrl: '',
                                sourceType: 'pdf',
                            }, selected: selectedFileIds
                                && selectedFileIds.some((selectedFileId) => selectedFileId === document.fileId) })) }), !('shareId' in document) && ((0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.bottomButtonContent, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faFilePlus, color: colors_1.Colors.NEUTRAL_00, size: 24 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.bottomButtonText, children: "Add Source" })] })), onPress: openAddSources }))] }), !('shareId' in document) && ((0, jsx_runtime_1.jsx)(AddSources_1.default, { document: document, isOpen: isAddOpened, onClose: closeSourceModal }))] }));
}
;
const styles = react_native_1.StyleSheet.create({
    content: {
        gap: 16,
        flex: 1,
        paddingHorizontal: 24,
        paddingVertical: 32,
        borderRadius: 8,
        width: '100%',
    },
    header: {
        flexDirection: 'row',
        gap: 8,
    },
    title: {
        fontSize: 20,
        color: colors_1.Colors.white,
        lineHeight: 28,
        fontWeight: '500',
        flex: 1,
    },
    description: {
        alignSelf: "stretch",
        fontSize: 14,
        lineHeight: 24,
        textAlign: "left",
        color: colors_1.Colors.DARK_100
    },
    closeContainer: {
        padding: 8,
    },
    sourcesContainer: {
        gap: 4,
    },
    bottomButtonContent: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 12,
    },
    bottomButtonText: {
        color: colors_1.Colors.NEUTRAL_00,
        fontSize: 16,
        fontWeight: '500',
    },
});
